import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
    RaisedButton,
    Dialog,
    IconButton,
    DatePicker,
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui';
import { TextField } from 'redux-form-material-ui';
import RemoveCircle from 'material-ui/svg-icons/content/remove-circle-outline';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import Pagination from 'components/Libs/Pagination';
import _, { defaults } from 'lodash';
import { getServiceProvidersHistory } from 'services/regions/serviceProvider';
import { fromUTC, toUTC } from 'helpers/dates';
import styles from 'styles';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';


const dialogStyles = {
    contentStyle: { width: '76%', padding: '20px', maxWidth: 'unset' },
};
const statusesList = [
    { name: 'All', value: null },
    { name: 'Approved', value: ['approved'] },
    { name: 'Rejected', value: ['rejected'] },
];

class ServiceProvidersHistoryDialog extends React.Component {
    constructor(props) {
        super(props);
        let pagination = {};
        pagination = defaults(pagination, {
            page: 1,
            filters: {
                query: '',
                dateFrom: '',
                dateTo: '',
                statuses: null,
            },
            limit: 25,
        });
        this.state = {
            rowsPerPage: [25, 50, 100],
            pagination,
            serviceProvidersHistory: [],
            total: 0,
        };
    }

    componentDidMount() {
        this.updateRows();
    }

    updateRows = async (state = this.state) => {
        const portId = window.location.pathname.split('/').slice(-1)[0];
        const { page, limit, filters } = state.pagination;

        const res = await getServiceProvidersHistory(portId, { page, limit, filters });
        this.setState({ serviceProvidersHistory: res.data, total: res.total });
    }

    onRequestClose = () => {
        this.props.toggle();
    }

    handleChangeSearch = (e, value) => {
        const pagination = {
            ...this.state.pagination,
            page: 1,
            filters: {
                ...this.state.pagination.filters,
                query: value,
            },
        };
        this.setState({
            pagination,
        });
    }

    handleSearch = () => {
        this.updateRows();
    }

    handleStartDateFilter = (e, date) => {
        const pagination = {
            ...this.state.pagination,
            page: 1,
            filters: {
                ...this.state.pagination.filters,
                dateFrom: toUTC(date),
            },
        };
        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleEndDateFilter = (e, date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59));
        const pagination = {
            ...this.state.pagination,
            page: 1,
            filters: {
                ...this.state.pagination.filters,
                dateTo: newDate.toISOString(),
            },
            
        };
        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleRemoveDate = (type) => {
        const state = _.cloneDeep(this.state);
        
        if (type === 'from') {
            state.pagination.filters.dateFrom = '';
        } else if (type === 'to') {
            state.pagination.filters.dateTo = '';
        }
        
        this.setState({
            ...state,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleChangePagination = ({ page, numberOfRows }) => {
        this.setState({
            pagination: {
                ...this.state.pagination,
                page,
                limit: numberOfRows,
            },
        }, () => {
            this.updateRows(this.state);
        });
    }
    handleSelectStatus = (ev, i, value) => {
        const pagination = {
            ...this.state.pagination,
            page: 1,
            filters: {
                ...this.state.pagination.filters,
                statuses: value,
            },
            
        };
        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }
    render() {
        const { open } = this.props;
        const {
            pagination: {
                filters: {
                    query, dateFrom, dateTo, statuses,
                }, page, limit,
            },
            rowsPerPage,
            serviceProvidersHistory,
            total, 
        } = this.state;
        const minDate = new Date();
        const maxDate = new Date();
        
        minDate.setFullYear(minDate.getFullYear() - 1);
        maxDate.setFullYear(maxDate.getFullYear() + 1);

        return (
            <Dialog
                open={open}
                contentStyle={dialogStyles.contentStyle}
                onRequestClose={this.onRequestClose}
                paperClassName='dialog-service-provider'
                bodyStyle={{ overflowY: 'auto' }}
                modal
            >
                <Fragment>
                    <div className='title-wrapper'>
                        <h2 className='title'>
                            Service Provider History
                        </h2>
                        <IconButton onClick={this.onRequestClose}>
                            <NavigationClose color="#B3B3B3" />
                        </IconButton>
                    </div>
                    
                    <div className='service-providers-history'>
                        <div className='service-providers-history__header'>
                            <div className='service-providers-history__header-item'>
                                <TextField
                                    defaultValue={query}
                                    value={query}
                                    onChange={this.handleChangeSearch}
                                    hintText='Search'
                                    ref='search'
                                    onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                            event.preventDefault();
                                            this.handleSearch();
                                        }
                                    }}
                                />
                            </div>
                            <div className='service-providers-history__header-item'>
                                <RaisedButton
                                    label='Search'
                                    style={styles.RaisedButton}
                                    primary
                                    onClick={this.handleSearch}
                                />
                            </div>
                            <div className='service-providers-history__header-item'>
                                <SelectField
                                    style={{ width: '100%' }}
                                    fullWidth
                                    autoWidth
                                    value={statuses}
                                    onChange={this.handleSelectStatus}
                                >
                                    {statusesList.map((s, key) =>
                                        <MenuItem key={key} style={styles.menuItemCSS} value={s.value} primaryText={s.name} />)}
                                </SelectField>
                            </div>
                            <div className='service-providers-history__header-item'>
                                <Pagination
                                    total={total}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    numberOfRows={limit}
                                    updateRows={this.handleChangePagination}
                                />
                            </div>
                        </div>
                        <div className='service-providers-history__filters'>
                            <div className='service-providers-history__filters-item'>
                                <DatePicker 
                                    floatingLabelText='Filter start date:'
                                    autoOk
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    textFieldStyle={{ width: '120px' }}
                                    shouldDisableDate={dateSelected => dateSelected.getTime() > new Date(dateTo).getTime()}
                                    onChange={this.handleStartDateFilter}
                                    value={dateFrom ? fromUTC(dateFrom) : undefined}
                                />
                                <IconButton
                                    style={{ margin: '25px 7px 0 -7px' }}
                                    disabled={!dateFrom}
                                    onClick={() => this.handleRemoveDate('from')}
                                >
                                    <RemoveCircle
                                        color={dateFrom ? 'red' : 'black'}
                                    />
                                </IconButton>
                                
                            </div>
                            <div className='service-providers-history__filters-item'>
                                <DatePicker
                                    floatingLabelText='Filter end date:'
                                    autoOk
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    textFieldStyle={{ width: '120px' }}
                                    shouldDisableDate={dateSelected => dateSelected.getTime() < new Date(dateFrom).getTime()}
                                    onChange={this.handleEndDateFilter}
                                    value={dateTo ? fromUTC(dateTo) : undefined}
                                />
                                <IconButton
                                    style={{ margin: '25px 0 0 -7px' }}
                                    disabled={!dateTo}
                                    onClick={() => this.handleRemoveDate('to')}
                                >
                                    <RemoveCircle
                                        color={dateTo ? 'red' : 'black'}
                                    />
                                </IconButton>
                            </div>
                        </div>
                        <div className='table-body service-providers-history__table'>
                            <Table selectable={false}>
                                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow>
                                        <TableHeaderColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                                            company
                                        </TableHeaderColumn>

                                        <TableHeaderColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                                            activity
                                        </TableHeaderColumn>

                                        <TableHeaderColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                                            address
                                        </TableHeaderColumn>

                                        <TableHeaderColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                                            PIC
                                        </TableHeaderColumn>

                                        <TableHeaderColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                                            phone
                                        </TableHeaderColumn>
                                        <TableHeaderColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                                            email
                                        </TableHeaderColumn>
                                        <TableHeaderColumn style={{ ...styles.tableRowColumnCSS, width: '21%' }}>
                                            by User
                                        </TableHeaderColumn>
                                        
                                    </TableRow>
                                </TableHeader>

                                <TableBody displayRowCheckbox={false}>
                                    {
                                        serviceProvidersHistory.map(item => 
                                            item.newServiceProvider && (<Row
                                                key={item.newServiceProvider._id + item.statusAt}
                                                item={item}
                                            />))
                                    }
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </Fragment>
            </Dialog>
        );
    }
}

class Row extends React.Component {
    render() {
        const {
            item: {
                newServiceProvider: {
                    name, activities, address, PIC, phones, emails, 
                }, statusAt, status, statusBy: { email }, 
            }, 
        } = this.props;

        return (
            <TableRow>
                <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                    { name }
                </TableRowColumn>

                <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                    { activities.join(', ') }
                </TableRowColumn>

                <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                    { address }
                </TableRowColumn>

                <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                    { PIC }
                </TableRowColumn>
                <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                    { phones.map((phone, phoneIndex) => (<div key={phoneIndex}>{`${phone.code} ${phone.phone}` }</div>)) }
                </TableRowColumn>
                <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '13%' }}>
                    { emails.map((em, emIndex) => (<div key={emIndex}>{ em }</div>))}
                </TableRowColumn>
                <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '21%' }}>
                    <div className='service-providers-history__table-cell status-at'>
                        <div className='status' style={status === 'approved' ? { color: '#4D9E0E' } : { color: '#E34848' }}>{status}</div>
                        <div>{fromUTC(statusAt).toLocaleString()}</div>
                    </div>
                    <div>
                        <div>{`by ${email}`}</div>
                    </div>
                </TableRowColumn>
            </TableRow>
        );
    }
}

ServiceProvidersHistoryDialog.propTypes = {};

ServiceProvidersHistoryDialog.defaultProps = {};
export default ServiceProvidersHistoryDialog;



// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog.jsx